export default __webpack_public_path__ + "static/media/article.1e3beb5b.png";